module.exports = __webpack_public_path__ + "static/media/Experience - Hexagon 1.ddaf2ab1.png";